export default "__VITE_ASSET__9dbbc6b8__"